"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getCityStateZipString = function (address) {
    if (address === void 0) { address = {}; }
    var addressElements = [];
    if (address.city && address.state) {
        addressElements.push("".concat(address.city, ","));
        addressElements.push("".concat(address.state));
    }
    if (address.city && !address.state) {
        addressElements.push("".concat(address.city));
    }
    if (!address.city && address.state) {
        addressElements.push(address.state);
    }
    if (address.zip) {
        addressElements.push(address.zip);
    }
    return addressElements.join(' ');
};
exports.default = getCityStateZipString;
